import Api from '~/config/Api'
const endpoint = Api.offers

export default {
  async get (offerId) {
    const detailEndpoint = endpoint + '/' + offerId
    const { data } = await useApi(detailEndpoint)

    return data
  },
  async create (link) {
    const createOfferEndpoint = endpoint
    const { data } = await useApi(createOfferEndpoint, {
      method: 'POST',
      body: {
        link
      }
    })

    return data
  }
}
